import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import Login from "./pages/Login";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      
      {/* Delegate all dashboard routes to App */}
      <Route path="/dashboard/online/*" element={<App />} />
      
      <Route path="/" element={<Navigate to="/dashboard/online" replace />} />
    </Routes>
  </BrowserRouter>
);
